export const ExhibitionsPictures = [
    {
        "id": 1,
        "title" : "Exhibitions",
        "description" : "拍摄于伦敦 Photographed in London",
        "firstPic" : "https://s2.loli.net/2025/03/31/zIx92d5ZvMCFjiB.jpg",
        "pics" : [ {
            "src" : "https://files.seeusercontent.com/2026/06/27/Ks1o/be0daf5a_oHLIfnCMzDAwYlm.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/Dcn4/02dff895_v83JxGVh6pLnKub.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/wHm7/a64d9bfe_LsWUiaKQgMdzb6n.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/ciU0/4a7512f3_RJanP46Q2WZlKbA.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/0gGi/a0334830_2qIW8VbkjEfaixA.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/6oKj/f41e6e2e_S6QD2VALrMwcXTB.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/Ja2i/7ceda0b1_sShANf9rx6LPmGU.jpg",
            "description" : ""
        }, {
            "src" : "https://s2.loli.net/2025/03/31/zIx92d5ZvMCFjiB.jpg",
            "description" : ""
        } ]
    },
    {
        "id": 2,
        "title" : "Exhibitions",
        "description" : "拍摄于伦敦 Photographed in London",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/zLo1/c64b7d4d_wPv8OBhs6Nl1Gmq.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/Ab4c/4da72dca_vDxH8sZe7yU2tE9.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/4pBk/22279c7d_Zh42OAvITaiMlc5.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/4Bmz/76a9c421_RhaWECUAJtimeHd.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/dpW6/6222eab0_r32shUQbT6wBYd9.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/zLo1/c64b7d4d_wPv8OBhs6Nl1Gmq.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/Us6h/ca2b5701_VPtlrJFSiNT7vhq.jpg",
          "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/Mas5/06f1ef71_nmtbu4XWNTyzCer.jpg",
            "description" : ""
        } ]
      },
    {
        "id": 3,
        "title" : "Events",
        "description" : "",
        "firstPic" : "https://files.seeusercontent.com/2026/06/27/g3fH/45deb6d2_FpUI1nMRgyNqwdA.jpg",
        "pics" : [ {
            "src" : "https://s2.loli.net/2025/12/19/pRoe3UGhWMD6N4q.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/4Pmi/2e4d0458_8fV2Cxs6UF4OgEQ.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/g3fH/45deb6d2_FpUI1nMRgyNqwdA.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/2plL/dee8a85a_rmFg75YhleBDZTA.jpg",
            "description" : ""
        },{
            "src" : "https://files.seeusercontent.com/2026/06/27/2Efg/85933d9b_TJvIaDLRr2yKVsu.jpg",
            "description" : ""
        }, {
            "src" : "https://s2.loli.net/2025/12/19/xWAjmht2esL8vVz.jpg",
            "description" : ""
        }, {
            "src" : "https://files.seeusercontent.com/2026/06/27/0Xve/3b09d344_JcMuy5Hj6lOdebQ.jpg",
            "description" : ""
        } ]
    },
      {
        "id": 4,
        "title" : "Exhibitions",
        "description" : "拍摄于伦敦 Photographed in London",
        "firstPic" : "https://s2.loli.net/2025/03/31/qehuKWH1U2yigCx.jpg",
        "pics" : [ {
          "src" : "https://files.seeusercontent.com/2026/06/27/mk0V/a38dabaa_ncvEXMhu5YVypk4.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/O3lg/0a982b8b_Z8zrYhsPnSpJOtG.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/x9wR/461717a4_Va6eWKbFLy4XkI5.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/8Fgf/8227cd76_Q2rfFjcwAdn9IMP.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/d3Vy/f01581b7_5M48jrVgQqOAkLG.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/7Dml/bbf6ccd9_KGCRYHTchwE1NFe.jpg",
          "description" : ""
        }, {
          "src" : "https://s2.loli.net/2025/03/31/qehuKWH1U2yigCx.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/Gpt7/6660f6ae_Kz3rxpYIWMlmBEd.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/0zVz/10a7f6d5_Iizpc38glYPVb5R.jpg",
          "description" : ""
        }, {
          "src" : "https://files.seeusercontent.com/2026/06/27/0jNj/33d7f02b_XeQr8pdluTivs5P.jpg",
          "description" : ""
        } ]
      },
  {
    "id": 5,
    "title": "Ant Group",
    "description": "",
    "firstPic": "https://files.seeusercontent.com/2026/07/01/0cTa/cover.jpg",
    "pics": [
      {
        "src": "https://files.seeusercontent.com/2026/07/01/0cTa/cover.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/y7Mn/DSC05237-opq3011139804.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/t7Ku/DSC05252-opq3011150784.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/8sqR/DSC05254-opq3011140999.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Vww5/DSC05269-opq3011150961.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/bw8H/DSC05274-opq3011150996.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/2vWy/DSC05276-opq3011151006.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Rtd1/DSC05278-opq3011141185.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/hO4r/DSC05280-opq3011141189.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Sdn7/DSC05308-opq3011141386.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/dRz7/DSC05335-opq3011151638.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Hz6f/DSC05348-opq3011141950.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/3yXt/DSC05379-opq3011152336.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/7Otq/DSC05384-opq3011142540.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Oq9y/DSC05386-opq3011152396.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Ac7r/DSC05388-opq3011142581.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/K6ir/DSC05414-opq3011142749.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/G5qh/DSC05419-opq3011142807.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/h6sR/DSC05543-opq3011153599.jpg",
        "description": ""
      },
      {
        "src": "https://files.seeusercontent.com/2026/07/01/Owy8/DSC05599-opq3011145231.jpg",
        "description": ""
      }
    ]
  }
];
